// extracted by mini-css-extract-plugin
module.exports = {"checkbox-input":"input_group_checkbox-input__XvxmS","check-label":"input_group_check-label___AC4g","feedback":"input_group_feedback__cpUFq"};